import { BaseTicketController } from '../../../../common/base/ticketController';

export class AuthorizationController extends BaseTicketController {
  constructor(controllerService, ticketService) {
    'ngInject';
    super({ controllerService, ticketService });
  }

  $onInit() {
    super.$onInit();
  }

  submit() {
    return this.ticketService.acceptOutgoing(this.ticket.id);
  }

  reject(reasons) {
    return this.ticketService.reject(this.ticket.id, reasons);
  }
}
